import i18next from "i18next";

export const SERVICE_URL = 'https://api.sentola.ru';
// export const SERVICE_URL = 'http://localhost:3000';

export const PLAN_AMOUNTS: Record<'FREE' | 'PREMIUM' | 'FOREVER', number> = {
    FREE: 0,
    PREMIUM: 10,
    FOREVER: 297,
};

export const isDev = import.meta.env.DEV;
export const isProd = import.meta.env.PROD;

export const getApexNoData = (): ApexCharts.ApexOptions['noData'] => ({
    text: i18next.t("no_data_to_display"),
    align: 'center',
    verticalAlign: 'middle',
    offsetX: 0,
    offsetY: 0,
    style: {
        color: "#999",
        fontSize: '18px',
    }
});
